import { NgModule  } from '@angular/core';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { AppConfig } from './app.config';
import { AuthenticactionService } from './_services/authentication.service';
import { SessionService } from './_services/session.service';
import { DocumentSigningComponent } from './components/document-signing/document-signing.component';
import { DocumentPendingComponent } from './components/document-pending/document-pending.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavbarComponent,
    FooterComponent,
    DocumentSigningComponent,
    DocumentPendingComponent,
    SidebarComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    RouterModule
  ],
  providers: [
    AppConfig,
    AuthenticactionService,
    SessionService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
